module.exports = __webpack_public_path__ + "img/5.602f1a78.png";